function normalizeViewLabel(viewLabel) {
    var normalized = '';
    var lastWasHyphen = false;
    for (var i = 0; i < viewLabel.length; i++) {
        var ch = viewLabel.charAt(i);
        var isAlphaNumeric = (ch >= 'A' && ch <= 'Z') ||
            (ch >= 'a' && ch <= 'z') ||
            (ch >= '0' && ch <= '9');
        if (isAlphaNumeric) {
            normalized += ch;
            lastWasHyphen = false;
            continue;
        }
        if (!lastWasHyphen) {
            normalized += '-';
            lastWasHyphen = true;
        }
    }
    var start = 0;
    while (start < normalized.length && normalized.charAt(start) === '-') {
        start++;
    }
    var end = normalized.length;
    while (end > start && normalized.charAt(end - 1) === '-') {
        end--;
    }
    return normalized.slice(start, end);
}
export function buildOmniExportRows(visibleRows, ergSiteHeader, metricKey) {
    return visibleRows.map(function (visibleRow) {
        var _a;
        var row = (_a = {}, _a[ergSiteHeader] = visibleRow.erg.bpgName, _a);
        visibleRow.cells.forEach(function (item) {
            row[item.site.siteName] = item.cell.metrics.get(metricKey).value || item.resolved.displayValue;
            if (row[item.site.siteName] === 'N/A') {
                row[item.site.siteName] = '-';
            }
        });
        return row;
    });
}
export function buildOmniExportFileBaseName(viewLabel, fiscalYear, isFilterActive, now) {
    var fiscalYearSuffix = fiscalYear ? fiscalYear.slice(-2) : '';
    var normalizedView = viewLabel
        ? normalizeViewLabel(viewLabel)
        : 'View';
    var fiscalYearPart = fiscalYearSuffix ? 'FY' + fiscalYearSuffix : 'FY';
    var filteredSuffix = isFilterActive ? '_filtered' : '';
    var timestamp = (now || new Date()).toISOString().slice(0, 10);
    return 'Omnidashboard_' + fiscalYearPart + '_' + normalizedView + filteredSuffix + '_' + timestamp;
}
